import type React from 'react';
import { Box, Divider, Modal } from '@zillow/constellation-10';
import { drawerAlignmentStyles, drawerBodyStyles, drawerWrapperStyles } from './styles';
import { cx } from '../../../styled-system/css';
import useModal from '../../hooks/useModal';

export type DrawerProps = {
  alignment?: 'left' | 'right';
  renderHeader?: React.ReactNode;
  renderBody?: React.ReactNode;
  renderFooter?: React.ReactNode;
  onClose?: () => void;
  shouldCloseOnOutsideClick?: boolean;
  className?: string;
};

export default function Drawer({
  alignment = 'right',
  renderHeader,
  renderBody,
  renderFooter,
  onClose,
  shouldCloseOnOutsideClick = false,
  className,
}: DrawerProps) {
  const { clearModal } = useModal();

  const handleClose = () => {
    clearModal();
    if (onClose) {
      onClose();
    }
  };

  // Build className based on alignment
  const drawerClassName = cx(drawerWrapperStyles, drawerAlignmentStyles[alignment], className);

  return (
    <Modal.Root
      open={true}
      onOpenChange={(open) => !open && handleClose()}
      useDismissProps={{
        outsidePress: shouldCloseOnOutsideClick,
        escapeKey: true,
      }}
    >
      <Modal.Portal>
        <Modal.Content className={drawerClassName}>
          {renderHeader && (
            <>
              <Modal.Header>{renderHeader}</Modal.Header>
              <Divider />
            </>
          )}
          {renderBody && <Box css={drawerBodyStyles}>{renderBody}</Box>}
          {renderFooter && (
            <>
              <Divider />
              <Modal.Footer>{renderFooter}</Modal.Footer>
            </>
          )}
          <Modal.CloseButton />
        </Modal.Content>
      </Modal.Portal>
    </Modal.Root>
  );
}
